export const InstallDomain = {
  flow: 'y',
  gap: 'C1',
  P: {
    color: 'inactive',
    margin: '0',
    Text: {
      text: '{{ publish.dns.step1 | polyglot }}'
    },
    LabeledHighlight: {
      text: (el) => el.getRootState().domain
    }
  },
  ARecord: {
    P: {
      color: 'inactive',
      margin: '0 - Z2',
      text: '{{ publish.dns.step2 | polyglot }}'
    },
    Terminal: {
      width: 'fit-content',
      Icon: {},
      value: '104.18.10.164'
    },
    Terminal2: {
      extends: 'Terminal',
      value: '104.18.11.164'
    }
  },
  TxtRecord: {
    P: {
      color: 'inactive',
      margin: '0 - Z2',
      text: '{{ publish.dns.step3 | polyglot }}'
    },
    CodePreviewWithTitle: {
      margin: 'Z1 0 0',
      Title: null,
      value: '// txt_record',
      Buttons: {
        Link: null,
        FrameworkSwitcher: null
      }
    }
  }
}
